<template>
  <window-container>
    <div style="font-size:18px;padding:10px;">{{ $route.params.type.toUpperCase() }}#{{ $route.params.id }}&nbsp;Files</div>
    <div class="order-photo card">
      <div>
        <ul class="el-upload-list el-upload-list--picture-card" v-if="list.length > 0">
          <li tabindex="0" class="el-upload-list__item is-success" v-for="item in list" :key="item.id">
            <img :src="'https://erp.cystrontech.com/oss/1565046496069.png'" alt="" class="el-upload-list__item-thumbnail"/>
            <a class="el-upload-list__item-name" @click="handleEditName(item)">
              <i class="el-icon-edit"></i>{{ item.name }}
            </a>
            <span style="display:block;line-height:18px;font-size:12px;text-align:right;padding-right:4px;">
              {{ item.oper_name }}&nbsp;{{ item.upload_time.substr(5, 11) }}
            </span>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePreview(item)">
                <i class="el-icon-download"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="handleRemove(item)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </li>
        </ul>
        <el-upload
          class="el-upload el-upload--picture-card"
          :action="baseUrl + 'api/upload'"
          :headers="uploadHeaders"
          :show-file-list="false"
          :on-success="handleScucess">
            <i class="el-icon-plus"></i>
        </el-upload>
      </div>
    </div>
  </window-container>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      baseUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        token: window.sessionStorage.getItem('token'),
        'Access-Control-Allow-Origin': '*'
      }
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    fetchList () {
      this.$http.get('/dbapi/order_photo_list?is_file=1&order_type=' + this.$route.params.type + '&order_id=' + this.$route.params.id).then(data => {
        this.list = data.list
      })
    },
    handleScucess (res, file) {
      if (res.success) {
        this.$message({ type: 'success', message: res.message })
        this.$http.post('/dbapi/order_photo_insert', {
          order_id: this.$route.params.id,
          order_type: this.$route.params.type,
          name: res.name,
          url: res.url,
          is_file: '1'
        }).then(() => {
          this.fetchList()
        })
      } else {
        this.$message({ type: 'error', message: res.message })
      }
    },
    handleRemove (item) {
      this.$confirm('确定要删除吗?', 'Confirm', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/order_photo_del', { id: item.id }).then(() => {
          this.fetchList()
        })
      })
    },
    handlePreview (item) {
      this.$open('https://erp.cystrontech.com/' + item.url)
    },
    handleEditName (item) {
      this.$prompt('修改照片标题', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: item.name
      }).then(({ value }) => {
        item.name = value
        this.$http.post('/dbapi/order_photo_edit', { id: item.id, name: value })
      })
    }
  }
}
</script>


<style lang="scss">
.order-photo {
  .el-upload-list--picture-card {
    .el-upload-list__item {
      height: 200px;
    }
    .el-upload-list__item-name {
      display: block;
      margin-right: 0;
      line-height: 18px;
      [class^=el-icon] {
        margin-right: 2px;
      }
    }
    .el-upload-list__item-thumbnail {
      height: 148px;
    }
    .el-upload-list__item-actions {
      height: 148px;
    }
  }
}
</style>

      